const eVersiones = {
    current: 'v3.37',
    urlVersion: 'https://gecros.com/versiones/'
};

export { eVersiones };